;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="71a28f0a-7886-4c88-9d9a-caae1e4bb7b6",e._sentryDebugIdIdentifier="sentry-dbid-71a28f0a-7886-4c88-9d9a-caae1e4bb7b6")}catch(e){}}();import classNames from '../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import React__default, { useContext, useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import 'react/jsx-runtime';
import BurgerMenu from '../../node_modules/.pnpm/@zooplus_icons@2.3.0_react-dom@18.3.1_react@18.3.1/node_modules/@zooplus/icons/dist/es/components/BurgerMenu.js';
import AppContext from '../../context/AppContext.js';
import '../../_virtual/_sentry-release-injection-file.js';
import { BURGER_PANEL_PORTAL } from '../../utils/constants.js';
import BurgerNavigation from '../BurgerNavigation/BurgerNavigation.js';
import styles from './MobileBurgerButton.module.scss.js';

const MobileBurgerButton = ({ label, id, className, }) => {
    const { showCategories, translations } = useContext(AppContext);
    const [burgerNav, setBurgerNav] = useState(false);
    const [isClientSide, setClientSide] = useState(false);
    const burgerButtonRef = useRef(null);
    /* Require below code to ensure on navigation panel activation background does not scroll */
    useEffect(() => {
        if (document && document.body) {
            document.body.style.overflow = burgerNav ? 'hidden' : '';
        }
        setClientSide(true);
    }, [burgerNav]);
    const handleClick = () => {
        // When the state is set to false, it must be close event,
        // hence bring back focus hamburger btn
        if (burgerNav && burgerButtonRef.current) {
            burgerButtonRef.current.focus();
        }
        setBurgerNav(!burgerNav);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("button", { type: "button", className: classNames(className, styles.hamburger), "data-zta": "hamburger-button", id: id, ref: burgerButtonRef, onClick: handleClick, "aria-expanded": burgerNav, "aria-label": label },
            React__default.createElement(BurgerMenu, { className: styles.hamburgerBox, "aria-label": translations.get('shop.header.accessible.catalog.menu') }),
            React__default.createElement("div", { className: styles.accessibleText }, label)),
        isClientSide &&
            showCategories &&
            createPortal(React__default.createElement(BurgerNavigation, { handleCloseClick: handleClick, open: burgerNav }), document.getElementById(BURGER_PANEL_PORTAL) ||
                document.body)));
};

export { MobileBurgerButton as default };
//# sourceMappingURL=MobileBurgerButton.js.map
